export default (fill) => (
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 137.2">
    <path fill="#D0E0E1" d="M0 12.5C0 5.6 5.6 0 12.5 0h54L100 34.1v90.7c0 6.9-6 12.5-12.9 12.5H12.5c-6.9 0-12.5-5.6-12.5-12.5V12.5z"/>
    <g fill="#6D7577">
        <path d="M31.2 88.8c2.3 0 4.2.6 5.5 1.7 1.3 1.1 2 2.7 2 4.7 0 1.5-.3 2.8-1 3.9s-1.8 1.9-3.3 2.3v.1c.7.1 1.3.4 1.7.7.4.3.8.7 1.1 1.2.3.4.5.9.6 1.5.1.6.2 1.1.3 1.7 0 .6.1 1.2.1 1.8 0 .6.1 1.2.2 1.8s.2 1.2.4 1.7.4 1 .8 1.4h-3.7c-.2-.3-.4-.6-.5-1-.1-.4-.1-.9-.2-1.5s0-1.1-.1-1.7c0-.6-.1-1.2-.2-1.8-.1-.6-.2-1.2-.3-1.7s-.4-1-.7-1.4c-.3-.4-.7-.7-1.2-1s-1.1-.4-1.9-.4h-8v10.5h-3.3V88.8h11.7zm.7 11.2c.7-.1 1.3-.3 1.8-.7.5-.3.9-.8 1.2-1.3.3-.6.5-1.3.5-2.2 0-1.2-.3-2.3-1-3-.7-.8-1.8-1.2-3.3-1.2H23v8.6h6.8c.7 0 1.4-.1 2.1-.2zM40 91.6v-2.8h19.7v2.8h-8.2v21.8h-3.3V91.6H40zM78.5 88.8v2.8H65.7v7.8H77v2.8H65.7v11.3h-3.3V88.8h16.1z"/>
    </g>
    <path fill="${fill? fill : '#A1AFAF'}" d="M66.5 0v34.1H100L66.5 0z"/>
</svg>`
)


// WEBPACK FOOTER //
// ./components/Icon/icons/files/rtf.jsx